import invariant from 'invariant';
import { useMocks } from './mocks';
function hasLeadingSlash(path) {
    return (path && /^\//.test(path)) || false;
}
function hasTrailingSlash(path) {
    return (path && /\/$/.test(path)) || false;
}
function getMockBaseUrl(serviceName, mockConfig) {
    const { origin, path, mockId } = mockConfig;
    // tslint:disable-next-line strict-type-predicates
    invariant(origin != null, 'Error creating mock base url: No mock origin has been configured.');
    invariant(path, 'Error creating mock base url: No mock path has been configured.');
    invariant(hasLeadingSlash(path), 'Error creating mock base url: Mock path must have a leading slash.');
    invariant(mockId, 'Error creating mock base url: No mock id has been set.');
    return `${origin}${path}/${mockId}/${serviceName}`;
}
export function getQueryString(params) {
    return Object.keys(params)
        .reduce((query, key) => {
        if (params[key] != null) {
            query.push(`${key}=${encodeURIComponent(params[key])}`);
        }
        return query;
    }, [])
        .join('&');
}
export function getUrl(config, mockConfig = {}, path = '', params = {}) {
    const { origin, path: basePath, name } = config;
    invariant(!basePath || hasLeadingSlash(basePath), 'config.path must have a leading slash');
    invariant(!hasTrailingSlash(basePath), 'config.path must not have a trailing slash');
    invariant(!path || hasLeadingSlash(path), 'path must have a leading slash');
    invariant(!hasTrailingSlash(path), 'path must not have a trailing slash');
    const baseUrl = useMocks(mockConfig)
        ? getMockBaseUrl(name, mockConfig)
        : origin;
    const url = `${baseUrl}${basePath || ''}${path}`;
    const queryString = getQueryString(params || {});
    return queryString ? `${url}?${queryString}` : url;
}
